import { getProductSlug } from '@util/urlHelpers';
import { useRouter } from '@bprogress/next';
import { useCreateListing } from 'app/create-listing/_context';
import { ChevronLeft } from 'lucide-react';

const ListingActionButtons = () => {
  const router = useRouter();
  const {
    setCurrentStep,
    currentStep,
    product,
    submitting: isLoading,
    variant,
    saveDraft,
    form,
    onSubmit,
    onSubmitError,
  } = useCreateListing();

  const goBack = () => {
    const productCameFromDataDepot = product?.sources?.find(
      (source) => source.collection === 'data_depot'
    );

    if (variant === 'edit-listing' && product) {
      router.push(getProductSlug(product));
      return;
    }

    if (productCameFromDataDepot) {
      setCurrentStep(0);
      return;
    }
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
      return;
    }

    router.back();
  };

  const handleSubmitClick = async () => {
    const categories = form.getValues('categories') || [];
    form.setValue('categories', categories);
    await form.handleSubmit(onSubmit, onSubmitError)();
  };

  return (
    <div className="flex w-full flex-col items-center justify-between gap-8 whitespace-nowrap px-4 md:px-0 lg:flex-row">
      <button
        onClick={goBack}
        className="flex w-full items-center justify-center gap-3 rounded-full border border-black px-10 py-6 text-body-md font-semibold text-black lg:w-fit"
        type="button"
        disabled={isLoading}
      >
        <ChevronLeft className="size-10" />
        Back
      </button>
      <div className="flex w-full flex-col items-center justify-between gap-8 px-4 md:px-0 lg:w-fit lg:flex-row">
        {variant === 'edit-listing' ? (
          <>
            {product?.is_draft && (
              <button
                onClick={saveDraft}
                className=" flex w-full items-center justify-center rounded-full bg-brand-lightest-gray px-10 py-6 text-body-md font-semibold text-black md:w-fit"
                type="button"
                disabled={isLoading}
              >
                {isLoading ? 'Updating...' : 'Update Draft'}
              </button>
            )}
            <button
              onClick={handleSubmitClick}
              disabled={
                product?.integration_info?.type === 'shopify' ||
                product?.integration_info?.type === 'ebay' ||
                isLoading
              }
              className="flex w-full items-center justify-center  rounded-full bg-brand-secondary px-10 py-6 text-body-md font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50"
              type="button"
            >
              {isLoading
                ? 'Processing...'
                : product?.is_draft
                ? 'Publish Item'
                : 'Save Changes'}
            </button>
          </>
        ) : (
          <>
            <button
              onClick={saveDraft}
              className="flex w-full grow items-center justify-center rounded-full border border-black  px-10 py-6 text-body-md font-semibold text-black lg:grow-0"
              type="button"
              disabled={isLoading}
            >
              {isLoading
                ? 'Saving...'
                : product.is_draft
                ? 'Update Draft'
                : 'Save As Draft'}
            </button>
            <button
              type="button"
              onClick={handleSubmitClick}
              className="flex w-full grow items-center justify-center rounded-full bg-brand-secondary px-10 py-6 text-body-md font-semibold text-white lg:grow-0"
              disabled={isLoading}
            >
              {isLoading ? 'Publishing...' : 'Publish Listing'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ListingActionButtons;
